import styled from 'styled-components'

import ValuePropPage from './ValuePropPage.div';

const ValuePropContainer = styled.div`
  & > ${ValuePropPage}:nth-of-type(even) {
    flex-direction: row-reverse;
    @media screen and (max-width: 45em) {
      flex-direction: column-reverse;
    }
  }
`;

export default ValuePropContainer;
